import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
// import { ConfigService } from 'src/app/shared/services/config.service';
// import { WebfeederModuleEnum, WebfeederServiceEnum, WebfeederSubscribeTypeEnum } from '../enums/webfeeder';
import { MessageParameterQuote, MessageWebFeeder } from '../models/message-webfeeder';
import { WebfeederScktService } from './webfeeder.sckt.service';
import { WebfeederSubscriptionsService } from './webfeeder-subscriptions.service';
import { WebfeederModuleEnum, WebfeederServiceEnum, WebfeederSubscribeTypeEnum } from '../enums/webfeeder';
import { ConfigService } from '@services/webFeeder/config.service';
import { LogService } from './log.service';

// import { WebfeederSubscriptionsService } from './webfeeder-subscriptions.service';
// import { WebfeederScktService } from './webfeeder.sckt.service';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseWebfeederScktConsumerService {

  protected module?: WebfeederModuleEnum;
  protected service?: WebfeederServiceEnum;
  protected delay?: string;
  protected messageType?: string;
  protected typeCommand?: string;
  protected quantidade?: string;

  protected webFeederScktSvc: WebfeederScktService
  protected _logSvc: LogService
  protected webFeederSubscriptionSvc: WebfeederSubscriptionsService
  protected authSvc: ConfigService
  protected abstract getSubjectOfSubscription(subscriptionKey: string): Observable<any> | undefined

  constructor(
    module: WebfeederModuleEnum,
    service: WebfeederServiceEnum,
    public instanceInjector: Injector
  ) {

    this.module = module;
    this.service = service;

    this._logSvc = this.instanceInjector.get(LogService);
    this.webFeederScktSvc = this.instanceInjector.get(WebfeederScktService);
    this.webFeederSubscriptionSvc = this.instanceInjector.get(WebfeederSubscriptionsService);
    this.authSvc = this.instanceInjector.get(ConfigService);
    this.initService()
  }

  initService() {
    this.webFeederScktSvc.subject.subscribe(
      (message) => {
        let subscriptionKey = this.getMessageIdentifier(message);
        if (message && this.webFeederSubscriptionSvc.hasSubscription(subscriptionKey)) {
          let subs = this.webFeederSubscriptionSvc.getSubscription(subscriptionKey)

          if (subs?.subject) {
            subs?.subject.next(message)
          }
        }
      }
    )
  }

  getWebfeederScktToken(){
    return  this.authSvc.getTokenGraphic()
  }

  protected getMessageIdentifier(message: any) {
    return btoa(`${this.module}|${this.service}|${message.parameter}`);
  }

  protected getSubscriptionKeyToRegister(dataMsg: any) {
    return btoa(`${dataMsg.module}|${dataMsg.service}|${dataMsg.parameterGet}`)
  }

  async on(params?: any, format?: string[]) {

    const messageParameter = this.getMessageParameter(params, format)

    const dataMsg: MessageWebFeeder = this.getMessageWebFeeder(messageParameter,params, format)

    let subscriptionKey = this.getSubscriptionKeyToRegister(dataMsg);

    await this.registerSubscription(subscriptionKey, dataMsg, format);
    return this.getSubjectOfSubscription(subscriptionKey)
  }

  getMessageParameter(params?: any, format?: string[]) {
    const messageParameter = new MessageParameterQuote();
    messageParameter.subsbribetype = WebfeederSubscribeTypeEnum.SUBSCRIBE; // Subscribe
    messageParameter.filter = format?.join(',');
    messageParameter.delay = this.delay;
    messageParameter.typecommand = this.typeCommand;
    messageParameter.quantidade = this.quantidade;

    return messageParameter;
  }

  getMessageWebFeeder(messageParameter?: any, params?: any, format?: string[]):any{
    const dataMsg: MessageWebFeeder = new MessageWebFeeder();
    dataMsg.token = this.getWebfeederScktToken();
    dataMsg.module = this.module;
    dataMsg.service = this.service;
    dataMsg.parameterGet = params?.symbol?.toLowerCase();
    dataMsg.parameters = messageParameter;

    return dataMsg;
  }

  async registerSubscription(subscriptionKey: string, dataMsg: MessageWebFeeder, format?: string[]) {
    if (!!!this.webFeederSubscriptionSvc.getSubscription(subscriptionKey)) {
      this.webFeederSubscriptionSvc.addSubscription(subscriptionKey, dataMsg, format);
      await this.send(dataMsg)
    }
  }

  async unregisterSubscription(subscriptionKey: string, dataMsg: MessageWebFeeder, format?: string[]) {
    if (!!!this.webFeederSubscriptionSvc.getSubscription(subscriptionKey)?.subject?.observers.length) {
      this.webFeederSubscriptionSvc.removeSubscription(subscriptionKey);
      await this.send(dataMsg)
    }
  }




  async off(params?: any) {

    const messageParameter = this.getMessageParameter(params)

    const dataMsg: MessageWebFeeder = this.getMessageWebFeeder(messageParameter,params)


    // const messageParameter = new MessageParameterQuote();
    // messageParameter.subsbribetype = WebfeederSubscribeTypeEnum.UNSUBSCRIBE; // Subscribe
    // messageParameter.delay = this.delay;
    // messageParameter.typecommand = this.typeCommand;

    // const dataMsg: MessageWebFeeder = new MessageWebFeeder();
    // dataMsg.token = this.getWebfeederScktToken();
    // dataMsg.module = this.module;
    // dataMsg.service = this.service;
    // dataMsg.parameterGet = params?.symbol?.toLowerCase();
    // dataMsg.parameters = messageParameter;

    let subscriptionKey = this.getSubscriptionKeyToRegister(dataMsg);

    if (!!!this.webFeederSubscriptionSvc.hasSubscription(subscriptionKey)) {
      return null;
    }

    await this.unregisterSubscription(subscriptionKey, dataMsg);

    return this.getSubjectOfSubscription(subscriptionKey)
  }



  async send(msg: any) {
    await this.webFeederScktSvc.sendMsg(msg);
  }
}
